<template>
    <div class="row">
        <div class="col-9">
            <div class="card block-target">
                <div class="card-header header-elements-inline pt-2 pb-2">
                    <h5 class="card-title font-weight-bold">Client Code List</h5>
                    <div class="header-elements">
                        <div class="list-icons">

                        </div>
                        <div class="list-icons mr-2  ml-auto">
                            <button class="btn btn-ums" v-if="hasRole($const.ROLES.SETTINGS_CODE_SAVE)" @click="setCreateInfoData">Create</button>
                        </div>
                        <div class="list-icons">
                            <block-target ref="blockTarget" @search="search" :class="'list-icons-item'"/>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <basic-table :fields="tableFields" name="templateList" :list="codeList" class="hover-table" @rowClickEvent="rowClickEvent">
                        <template v-slot:regDate="slotData">
                            {{slotData.data.sysRegDtm | datetimeFormat('HH:mm DD/MM/YYYY')}}
                        </template>
                    </basic-table>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="card">
                <div class="card-header">
                    <h5 class="card-title font-weight-bold">Info</h5>
                </div>
                <div class="card-body">
                    <basic-input label="Code" rule="required max:5" v-model="info.code" :disabled="!create"/>
                    <basic-input label="Code Name" rule="required max:50" v-model="info.codeNm"/>
                    <basic-switch :vertical="true" label="Use Yn" v-model="info.useYn"/>
                    <button class="btn btn-ums mt-3 w-100" @click="saveCode" v-if="hasRole($const.ROLES.SETTINGS_CODE_SAVE)">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "@/api/support"
    import BasicTable from "@/components/form/table/BasicTable";
    import BasicInput from "@/components/form/input/BasicInput";
    import BlockTarget from "@/components/block/BlockTarget";
    import BasicSwitch from "@/components/form/switch/BasicSwitch";
    import validation from "@/config/mixin/validation";
    import constant from "@/config/const/const";
    export default {
        name: "ClientCodeMng",
        components: {BasicSwitch, BasicTable,BasicInput,BlockTarget},
        mixins:[validation],
        data() {
            return {
                create:true,
                codeList: [],
                info:{
                    code:'',
                    codeNm:'',
                    useYn:'Y'
                },
                useYnShowAll:true,
                tableFields:[
                    {key:'code',label:'Code',width:'10%'},
                    {key:'codeNm',label:'Code Name',width:'35%'},
                    {key:'useYn',label:'Use Yn',width:'10%'},
                    {key:'register',label:'Register',width:'20%'},
                    {key:'sysRegDtm',label:'Reg Date',width:'20%',slot:'regDate'},
                ],
            }
        },
        mounted() {
            this.search()
        },
        methods: {
            saveCode: function() {
                if(!this.validationCheck()) return;
                let user = this.$store.getters[this.$const.GETTERS.GET_USER]
                if(this.create) {
                    let filtered = this.codeList.filter(item=>item.code === this.info.code)
                    if(filtered.length > 0) {
                        this.$notify.alert('Client code is already exist');
                        return
                    }
                }
                this.info.register = user.data.usrId
                api.saveClientCode(this.info).then((res) =>{
                    if(res.data.code===1000) {
                        this.search()
                        this.$store.dispatch(constant.ACTIONS.SET_CLIENT_CD)
                    } else {
                        this.$notify.error('Fail',res.data.message)
                    }
                })
            },
            search: function() {
                this.$refs.blockTarget.block()
                api.getClientCodeList().then((res) =>{
                    if(res.data.code===1000) {
                        this.codeList = res.data.content
                    } else {
                        this.$notify.error('Fail',res.data.message)
                    }
                }).finally(()=>{
                    this.$refs.blockTarget.unblock()
                })
            },
            setCreateInfoData: function() {
                this.create = true
                this.info = {
                    code:'',
                    codeNm:'',
                    useYn:'Y'
                }
            },
            rowClickEvent: function(item) {
                this.create = false
                this.info = item
            }
        }
    }
</script>

<style scoped>
    .message-comp-header {
        padding-top:0.8rem !important;
        padding-bottom:0.8rem !important;
    }
</style>
